import { ReactNode } from 'react'

import { astraTwMerge } from '../Utilities/astraTwMerge'

type Props = {
    children: ReactNode
    className?: string
}

/**
 * Card is a bordered surface that groups related content. It is only a container: it adds no padding or
 * layout, so the caller supplies those. Use Collapsible Card for a card whose body can be folded away.
 *
 * @summary for grouping related content on a bordered surface
 */
export const AstraCard = ({ children, className }: Props) => (
    <div className={astraTwMerge('rounded-xl border border-subtle bg-surface-base', className)}>{children}</div>
)
